/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import SchemaRegistry from "../../services/SchemaRegistry";
import * as pageControllers from "./PageController";
import LocationInfo from "../../LocationInfo";
import {deepEquals} from "../../util";
import {InternalErrorException, NotFoundException} from "../../Exceptions";

/**
 * Base resoure page. Renders controller component with correct props
 *
 */
class ResourceContainer extends React.Component {
    static propTypes = {
        params: PropTypes.shape({
            resource: PropTypes.string.isRequired,
            splat: PropTypes.string
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = this.getNewState(props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.resource !== nextProps.params.resource || !deepEquals(this.props.location, nextProps.location)) {
            this.setState(this.getNewState(nextProps));
        }
    }

    /**
     * Render controller component
     * @param Controller Controller component
     * @param params Params passed to controller component
     * @param isActive If controller is active (ie should process received actions)
     * @param isModal if controller should render its content into modal window
     * @returns {XML}
     */
    renderController(params, isActive, isModal, uiSchema, tabSchema) {
        let Controller = this.getController(tabSchema);
        if (!Controller) throw new NotFoundException();
        return (
            <Controller
                key={isModal ? "2" : "1"}
                basePath={this.state.basePath}
                params={{...params, isModal: isModal}}
                schema={uiSchema}
                controllerSchema={tabSchema}
                active={isActive}
                location={this.props.location}
                router={this.props.router}
                route={this.props.route}
            />
        );
    }

    render() {
        return (
            <div>
                {this.state.parentParams ? this.renderController(this.state.parentParams, false, false, this.state.parentUiSchema, this.state.parentTabSchema) : null}
                {this.renderController(this.state.currentParams, true, (this.state.parentParams != null), this.state.currentUiSchema, this.state.currentTabSchema)}
            </div>
        );
    }

    getNewState(props) {
        let basePath = this.getBasePath(props);
        let locationInfo = new LocationInfo(basePath, this.getFullPath(props), props.location.query);

        let rootSchema = this.getRootSchema(props.params.resource);

        let currentProps = _.clone(locationInfo.getLocationProps());
        let currentField = locationInfo.getResourceFieldPathWithoutTab();
        let tabField = locationInfo.getResourceFieldPath();
        let currentUiSchema = rootSchema.field(currentField);

        //let newResource = rootSchema.field(tabField).getResource();
        //if (newResource) currentProps.resource = newResource;

        let state = {
            basePath: basePath,
            currentParams: currentProps,
            currentUiSchema: currentUiSchema,
            currentTabSchema: rootSchema.field(tabField)
        };

        let parentProps = _.clone(locationInfo.getParentLocationProps());
        if (parentProps) {
            let parentField = locationInfo.getParentResourceFieldPathWithoutTab();
            let tabField = locationInfo.getParentResourceFieldPath();
            let parentUiSchema = rootSchema.field(parentField);

            //newResource = rootSchema.field(tabField).getResource();
            //if (newResource) parentProps.resource = newResource;

            state.parentParams = parentProps;
            state.parentUiSchema = parentUiSchema;
            state.parentTabSchema = rootSchema.field(tabField)
        } else {
            // Check if we have "ui:page" : "Modal" here:
            if (currentUiSchema.getPage() === "Modal") {
                // We should generate parent fields from locationstack last item:
                let parentField = locationInfo.getResourceFieldPathWithoutTab(-2);
                tabField = locationInfo.getResourceFieldPath(-2);
                parentProps = locationInfo.getLocationProps(-2);
                if (parentProps == null || parentField == null) throw new InternalErrorException("Modal without parent");

                //newResource = rootSchema.field(tabField).getResource();
                //if (newResource) parentProps.resource = newResource;

                state.parentParams = parentProps;
                state.parentUiSchema = rootSchema.field(parentField);
                state.parentTabSchema = rootSchema.field(tabField);
            } else {
                state.parentParams = null;
                state.parentUiSchema = null;
            }
        }

        return state;
    }

    /**
     * Detect resource page base path from location object
     */
    getBasePath(props) {
        let fullPath = this.getFullPath(props);
        let hash = fullPath.indexOf("#");
        if (hash >= 0) fullPath = fullPath.substring(0, hash);

        if (fullPath.startsWith("/")) fullPath = fullPath.substring(1);

        let pathItems = _.map(props.routes, function (r) {
            return r.path;
        });
        pathItems.shift();
        pathItems.pop();
        pathItems = pathItems.join("/").split("/");
        let fullPathItems = fullPath.split("/");
        return "/" + fullPathItems.slice(0, pathItems.length).join("/");
    }

    getFullPath(props) {
        return props.location.basename + props.location.pathname + (props.location.hash ? props.location.hash : "");
    }

    /**
     * Returns root Nav Schema for current resource
     * @param props
     * @returns {UiSchema}
     */
    getRootSchema(resource) {
        return SchemaRegistry.getNavigationSchemaObject(resource);
    }

    getController(uischema) {
        if (!uischema) return null;
        let componentName = uischema.getController();

        if (_.has(pageControllers, componentName)) return pageControllers[componentName];
        return null;
    }
}

export default ResourceContainer;
